import styled from 'styled-components'

export const DesktopView = styled.div`
  display: none;

  @media screen and (min-width: 1000px) {
    display: unset;
  }
`

export const MobileView = styled.div`
  display: unset;

  @media screen and (min-width: 1000px) {
    display: none;
  }
`

export const CardsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 40px;
`
